import { render, staticRenderFns } from "./report_query_2.vue?vue&type=template&id=d6ef4e78&scoped=true"
import script from "./report_query_2.vue?vue&type=script&lang=js"
export * from "./report_query_2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ef4e78",
  null
  
)

export default component.exports